/* @flow */

import { createReducer } from 'src/shared/core/util/reducerUtils';
import * as types from 'src/shared/domain/conversation/action/conversationActionTypes';

/*
 |------------------------------------------------------------------------------
 | Initial state
 |------------------------------------------------------------------------------
 */

const initialState = {
  isBeingRepliedTo: false,
  isBeingCreated: false,
};

/*
 |------------------------------------------------------------------------------
 | Reducers
 |------------------------------------------------------------------------------
 */

const handleReplyRequest = (state: Object) => ({
  ...state,
  isBeingRepliedTo: true,
});

const handleReplyFailure = (state: Object) => ({
  ...state,
  isBeingRepliedTo: false,
});

const handleReplySuccess = (state: Object) => ({
  ...state,
  isBeingRepliedTo: false,
});

const handleCreateRequest = (state: Object) => ({
  ...state,
  isBeingCreated: true,
});

const handleCreateFailure = (state: Object) => ({
  ...state,
  isBeingCreated: false,
});

const handleCreateSuccess = (state: Object) => ({
  ...state,
  isBeingCreated: false,
});

export default createReducer(initialState, {
  [types.REPLY_TO_CONVERSATION_REQUEST]: handleReplyRequest,
  [types.REPLY_TO_CONVERSATION_FAILURE]: handleReplyFailure,
  [types.REPLY_TO_CONVERSATION_SUCCESS]: handleReplySuccess,
  [types.CREATE_CONVERSATION_REQUEST]: handleCreateRequest,
  [types.CREATE_CONVERSATION_FAILURE]: handleCreateFailure,
  [types.CREATE_CONVERSATION_SUCCESS]: handleCreateSuccess,
});
